import { queryKeysBuilder } from '@/api/queries.utils';
import { beneficiariesQueryKeys } from '../beneficiaries/beneficiaries.query-keys';

const builder = queryKeysBuilder([...beneficiariesQueryKeys.all, 'employees']);

export const employeesQueryKeys = {
  all: builder(),
  list: builder('list'),
  one: (id: number) => builder('one', id),
  orders: (id: number) => builder('one', id, 'orders'),
  financialAccount: (id: number) => builder('financial-account', id),
  sites: builder('sites'),
  infinite: (params: object) => builder('infinite', params),
  selectable: builder('selectable'),
};
